(function () {
  'use strict';

  // Shared add-to-cart feedback for APO products (both generations). APO adds
  // via its own AJAX and skips the theme's native success flow, so the spinner
  // and the "added" checkmark burst never play on their own. This module gives
  // the bridges in blocks/apo-options.liquid a spinner + burst that reuse the
  // theme's own animation, whichever button drove the add (order bar or the
  // product-area buy button). Loaded on product pages from apo-options.liquid.

  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.apoAddFeedback) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function cartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { return c ? c.item_count : null; })
      .catch(function () { return null; });
  }

  // Watch a cart add (triggered elsewhere) and call onDone(success) once the
  // cart has grown AND stopped changing — classic APO adds the base line then
  // each option child line in separate calls, so we wait for the whole build
  // instead of reacting to the first bump. Polls /cart.js against a pre-add
  // baseline, so it works with or without Horizon's cart:update (APO never
  // emits it).
  function watch(onDone) {
    cartCount().then(function (baseline) {
      var tries = 0, last = baseline, stable = 0, grew = false;
      var iv = setInterval(function () {
        tries++;
        cartCount().then(function (n) {
          if (n != null) {
            if (baseline != null && n > baseline) grew = true;
            if (grew && n === last) stable++; else stable = 0;
            last = n;
            if (grew && stable >= 1) { clearInterval(iv); onDone(true); return; }
          }
          if (tries >= 16) { clearInterval(iv); onDone(grew); } // ~8s safety net
        });
      }, 500);
    });
  }

  // Play the theme's "added" checkmark burst on the exact button passed in, by
  // toggling [data-added] on IT. We deliberately do NOT call the
  // add-to-cart-component's animateAddToCart(): APO clones the buy button and
  // keeps the component's ref pointing at the hidden (0x0) original, so that
  // path fires the burst off-screen in the page corner. Buttons that already
  // carry the burst markup (the theme's real / APO-cloned buy buttons) just get
  // the toggle; buttons without it (the order bar) have the markup cloned in
  // from an existing one first, then reuse the same [data-added] CSS.
  function fireBurst(btn) {
    if (!btn) return;

    if (!btn.querySelector('.add-to-cart__added')) {
      var source = document.querySelector('.add-to-cart__added');
      if (!source) return; // nothing to clone — skip gracefully
      btn.classList.add('add-to-cart-button');
      // The label must be an .add-to-cart-text element so the burst CSS can
      // slide/fade it out while the checkmark reveals.
      var label = btn.querySelector('[data-pob-summary-label]');
      if (!label) {
        label = document.createElement('span');
        while (btn.firstChild) label.appendChild(btn.firstChild);
        btn.appendChild(label);
      }
      label.classList.add('add-to-cart-text');
      btn.appendChild(source.cloneNode(true));
    }

    btn.dataset.added = 'true';
    setTimeout(function () { btn.removeAttribute('data-added'); }, 1000);
  }

  // Convenience: show a spinner on the button while the add completes, then
  // clear it and — on success — play the burst.
  function feedback(btn) {
    if (!btn) return;
    btn.classList.add('is-loading');
    watch(function (success) {
      btn.classList.remove('is-loading');
      if (success) fireBurst(btn);
    });
  }

  window.apoAddFeedback = {
    cartCount: cartCount,
    watch: watch,
    fireBurst: fireBurst,
    feedback: feedback,
  };
})();
